import CustomCard from './CustomCard';

export default CustomCard;